
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

export default function Partnership() {
  const { t } = useTranslation('about');

  const steps = [
    {
      icon: 'ri-discuss-line',
      title: t('partnership.consultation'),
      description: t('partnership.consultationDesc')
    },
    {
      icon: 'ri-lightbulb-line',
      title: t('partnership.solution'),
      description: t('partnership.solutionDesc')
    },
    {
      icon: 'ri-settings-3-line',
      title: t('partnership.implementation'),
      description: t('partnership.implementationDesc')
    },
    {
      icon: 'ri-line-chart-line',
      title: t('partnership.optimization'),
      description: t('partnership.optimizationDesc')
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#0D1B2A] mb-4 tracking-tight">
            {t('partnership.title')}
          </h2>
          <p className="text-xl text-[#394B59] max-w-3xl mx-auto leading-relaxed">
            {t('partnership.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-[#F5F7FA] rounded-2xl p-6 h-full">
                <div className="w-12 h-12 bg-[#2E8BC0] rounded-lg flex items-center justify-center mb-4">
                  <i className={`${step.icon} text-xl text-white`}></i>
                </div>
                <div className="absolute -top-3 -left-3 w-8 h-8 bg-[#0D1B2A] rounded-full flex items-center justify-center text-white font-bold text-sm">
                  {index + 1}
                </div>
                <h3 className="text-lg font-semibold text-[#0D1B2A] mb-3">
                  {step.title}
                </h3>
                <p className="text-[#394B59] text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#0D1B2A] rounded-3xl p-12 lg:p-16 text-center">
          <h3 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            {t('partnership.cta')}
          </h3>
          <p className="text-xl text-[#C0C0C0] mb-8 max-w-2xl mx-auto">
            {t('partnership.ctaDesc')}
          </p>
          <Link to="/contact">
            <Button variant="primary" className="text-lg px-8 py-4 bg-[#2E8BC0] hover:bg-white hover:text-[#0D1B2A]">
              {t('partnership.cta')}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
